module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_11_m.2037a7f95f4cddea35657b6378000492.png";